export const RULEBOOK_IDS = {
  CUSTOM_PATIENT_SIMULATION: 'custom_patient_simulation',
};

/** @type {Record<string, { id: string, title: string, path: string }>} */
export const RULEBOOKS = {
  [RULEBOOK_IDS.CUSTOM_PATIENT_SIMULATION]: {
    id: RULEBOOK_IDS.CUSTOM_PATIENT_SIMULATION,
    title: 'Custom Patient Simulation',
    path: '/rulebooks/custom-patient-simulation.md',
  },
};

export function getRulebook(rulebookId) {
  return RULEBOOKS[rulebookId] || null;
}
